export enum WorkOrderRowState {

  Open = 1,
  Closed = 5

}
